const licenses = new WeakMap();

/** Associate immutable record IDs with a survey without adding them to its persisted answers. */
export function setSurveyLicenseContext(survey, license) {
  licenses.set(survey, {
    cityId: license?.city?.id,
    licenseId: license?.id
  });
}

/** Resolve the license owning a file question, including nested panels and matrices. */
export function getSurveyLicenseContext(question) {
  return licenses.get(question.survey) || {};
}
